/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Color } from '../models/Color';
import type { ForecastPointWeek } from '../models/ForecastPointWeek';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ForecastService {
    /**
     * Returns the complete list of temperature-color mappings
     * Returns the complete list of current temperature-color mappings.  Needed to accurately display the accurate color value in GUIs
     * @returns Color Returned when successful
     * @throws ApiError
     */
    public static getTemperatureMapList(): CancelablePromise<Array<Color>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/colors',
        });
    }
    /**
     * Returns a complete list of all symbolcodes and descriptions
     * @returns any Returned when successful
     * @throws ApiError
     */
    public static getSymbolCodes(): CancelablePromise<{
        symbol24_text?: Record<string, string>;
        symbol_text?: Record<string, string>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/symbols',
        });
    }
    /**
     * Returns forecast data grouped by day,3hour and hour
     * Returns forecast data grouped by day-intervals, 3hour-intervals (threeHours) and hours interval
     * @returns ForecastPointWeek Returned when successful
     * @throws ApiError
     */
    public static getForecastWeekByGeoLocation({
        geolocationId,
    }: {
        /**
         * id of geolocation object ('[lat],[lon]' rounded to 4 digits)
         */
        geolocationId: string,
    }): CancelablePromise<ForecastPointWeek> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/forecastpoint/{geolocationId}',
            path: {
                'geolocationId': geolocationId,
            },
            errors: {
                404: `Returned when geolocation is not found`,
            },
        });
    }
}
